// extracted by mini-css-extract-plugin
export default {"about_modal":"AboutSite_about_modal__jWV2o"};